import {
  Labels,
  Picture,
  OptimizelyEditProperty,
  VideoWithPoster,
  LinkHeroFrontpage,
} from "/App.Components";
import { HeroFrontpageProps } from "/Models/Generated/HeroFrontpageProps";
import "./HeroFrontpageMedium.scss";
import { useState } from "react";

const HeroFrontpageMedium = ({
  image,
  imagePropertyName,
  labels,
  heading,
  headingPropertyName,
  leadText,
  leadTextPropertyName,
  readMoreLink,
  readMoreLinkPropertyName,
  video,
}: HeroFrontpageProps) => {
  const [posterClicked, setPosterClicked] = useState(false);

  return (
    <div className="hero-frontpage-medium-norad">
      <div className="hero-frontpage-medium-norad__container">
        <div className="hero-frontpage-medium-norad__left">
          <OptimizelyEditProperty propertyName={imagePropertyName} clientRender>
            {image && !video && (
              <Picture
                {...image}
                pictureBehaviour="Cover"
                pictureAspectRatio="16/9"
                eagerLoading
              />
            )}
            {video && (
              <VideoWithPoster
                posterClicked={posterClicked}
                setPosterClicked={() => setPosterClicked(!posterClicked)}
                {...video}
                posterBehaviour="Cover"
                posterAspectRatio="16/9"
                eagerLoading
              />
            )}
          </OptimizelyEditProperty>
        </div>
        <div className="hero-frontpage-medium-norad__right">
          <div className="hero-frontpage-medium-norad__right-container">
            {labels && (
              <div className="hero-frontpage-medium-norad__tags">
                <Labels {...labels} />
              </div>
            )}
            <OptimizelyEditProperty propertyName={headingPropertyName}>
              {heading && (
                <h2 className="hero-frontpage-medium-norad__heading">
                  {heading}
                </h2>
              )}
            </OptimizelyEditProperty>
            <OptimizelyEditProperty propertyName={leadTextPropertyName}>
              {leadText && (
                <p className="hero-frontpage-medium-norad__lead-text">
                  {leadText}
                </p>
              )}
            </OptimizelyEditProperty>
            <OptimizelyEditProperty propertyName={readMoreLinkPropertyName}>
              <div className="hero-frontpage-medium-norad__link-container">
                {readMoreLink && <LinkHeroFrontpage {...readMoreLink} />}
              </div>
            </OptimizelyEditProperty>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroFrontpageMedium;
